import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import useWidth from '../../../components/Hooks/useWidth';
import useTeceoStyles from '../../../useTeceoStyles';

type WhoIsSigningViewerProps = {
  hide?: boolean;
  whoIsSigning: string;
};

const useStyles = makeStyles()((theme) => ({
  upperTitle: {
    color: theme.palette.grey[600],
    textTransform: 'uppercase',
    letterSpacing: 2,
    fontWeight: 300,
  },
}));

const WhoIsSigningViewer = ({ hide, whoIsSigning }: WhoIsSigningViewerProps) => {
  const { smallWidth } = useWidth();
  const { classes: teceoClasses } = useTeceoStyles();
  const { classes, cx } = useStyles();

  if (hide) {
    return null;
  }

  return (
    <>
      <Typography
        variant="h4"
        color="textSecondary"
        className={cx(
          teceoClasses.variantBody2,
          teceoClasses.secondaryTypography,
          smallWidth ? teceoClasses.upperTitle : classes.upperTitle,
        )}
      >
        {whoIsSigning}
      </Typography>
      <Box
        sx={{
          pt: 0.5,
        }}
      />
    </>
  );
};

export default WhoIsSigningViewer;
